exports.EXAMTYPE = {
  KOICA_TEST: 1, //코이카_테스트
  KHNP: 3, //코이카
  KOICA_UZ: 4, //코이카_우즈벡
  KOICA_INDOS: 5, //코이카_인도네시아
  KOICA_KAM: 6, //코이카_캄보디아
  KOICA_TAE: 7, //코이카_태국어
  KOICA_TETUM: 8, //코이카_테툼어
  KOICA_FRA: 9, //코이카_프랑스어
  KOICA_RAO: 10, //코이카_라오스어
  KOICA_NEPAL: 11, //코이카_네팔어
  KOICA_THIGAL: 12, //코이카_따갈로그어
  KOICA_RUS: 13, //코이카_러시아어
  KOICA_MONG: 14, //코이카_몽골어
  KOICA_MIAN: 15, //코이카_미얀마어
  KOICA_BENG: 16, //코이카_뱅골어
  KOICA_BET: 17, //코이카_베트남어
  KOICA_SURI: 18, //코이카_스리랑카어
  KOICA_SWALLI: 19, //코이카_스와힐리어
  KOICA_SPAIN: 20, //코이카_스페인어
  KOICA_ARAB: 21, //코이카_아랍어
  KOICA_AMHA: 22, //코이카_암하라어
  KOICA_ENG: 23, //코이카_영어
  KOICA_DERIZA: 24, //코이카_데리자어
  KOICA_KINYARWANADA: 25, //코이카_키냐르완다어
  KHNP_TEST: 26,
};

exports.EXAMSTATE = {
  READY: 0,
  //0~100 사이 값은 진행 중인 시험 단계
  DONE: 100,
  RATE_WAIT: 101, //평가 대기중
  RATE_DONE: 102, //평가 완료
};

exports.EXAMMEDIA = {
  VOICE: 1, //음성 데이터
  VIDEO: 2, //영상 데이터
};
